import proyectReducer from "./proyectReducer";
import authReducer from "./authReducer";
import {combineReducers, createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import {localStoregeTitle} from '../../Config/const';

function saveToLocalStorage(store) {
    try {
        //console.log('saveLocalStorage');
        //console.log(store);
        const serializedState = JSON.stringify(store);
        localStorage.setItem(localStoregeTitle, serializedState);
    } catch (e) {
        console.log(e);
    }
}

function loadFromLocalStorage() {
    try {
        //console.log('loadLocalStorage');
        const serializedState = localStorage.getItem(localStoregeTitle);
        //console.log(serializedState);
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

const persitedState = loadFromLocalStorage();

const rootReducer = combineReducers({
    auth: authReducer,
    proyect: proyectReducer,
});

let composeEnhancers = compose;

// This is for the redux-devtools-extension chrome extension https://github.com/zalmoxisus/redux-devtools-extension
if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const store = createStore(rootReducer, persitedState, composeEnhancers(applyMiddleware(reduxThunk)));

/*Actualiza el localstorage cada ves que se modifica el store*/
store.subscribe(() => saveToLocalStorage(store.getState()));
export default store;
